import React, { useEffect,useRef } from 'react'
import Terminal from "./components/Terminal";
import './Style/Portfolio.css';
import {Helmet} from "react-helmet";
import Fexatitle from "./components/Fexatitle";
import Typed from "typed.js";





const Portfolio = () => {


    const content = useRef(null);

    useEffect(() => {
        const typed = new Typed(content.current, {
            strings: ["I am a 15-year-old programmer with a strong passion for coding. Proficient in React, Shell, Python, and Rust, I am constantly seeking new challenges to enhance my skills and knowledge. With a dedicated and determined mindset, I strive to make a positive impact in the world of technology"], // Strings to display
            // Speed settings, try diffrent values untill you get good results
            startDelay: 300,
            typeSpeed: 1,
            backSpeed: 0,
            loop: false
        });

    }, []);
    return (
        <div className="portfolio_top">
        <h1 className="title">Fexa Portfolio</h1>
        <Helmet>
            <style>{'body { overflow: visible; background: #0b0e12; }'}</style>
        </Helmet>
            <section className="portfolio">
            <Terminal />
                <h1 className="heading">
                   Terminal
                </h1>

                <p className="subtitle">Not mine, mine orignal is better</p>
                <p className="content_p">
                    Terminal of truth, I m just lazy to write big easy and make it look good. So I just made this terminal.
                    <br />
                    <br />
                    Type Help to start

                </p>
                <Fexatitle />
                <p className={"subtitle_b"}>Currently only one, more soon</p>
            </section>
                <section className="portfolio_1">
                    <div className="about">
                        <h1 className="heading_about">
                            About
                        </h1>
                        <a href={"https://github.com/Godskull"}>
                <div className="parent_word">
                    <div className="container">
                        <div className="word-container">
                            <span className="letter">G</span>
                            <span className="letter">i</span>
                            <span className="letter">t</span>
                            <span className="letter">h</span>
                            <span className="letter">u</span>
                            <span className="letter">b</span>
                        </div>
                        <div className="word-container">
                            <span className="letter">G</span>
                            <span className="letter">i</span>
                            <span className="letter">t</span>
                            <span className="letter">h</span>
                            <span className="letter">u</span>
                            <span className="letter">b</span>
                        </div>
                    </div>
                </div>
                        </a>

                    <div className="content_p">
                        <span ref={content}></span>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Portfolio
